// extracted by mini-css-extract-plugin
export default {"p_tye":"_325018fe45","slcted":"_26dd7529e1","slc_color":"a2be0ca35d","item_p":"c2ad99d147","r0":"_99797fae68"};